import { Component, OnInit, Injector, OnDestroy, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import {
    LinearChartDto,
    AnalyticsDashboardServiceProxy,
} from '@shared/service-proxies/service-proxies';
import * as moment from 'moment';
import { finalize } from 'rxjs/operators';
import { WidgetComponentBaseComponent } from '../widget-component-base';

@Component({
    selector: 'app-widget-sales-flight-type',
    templateUrl: './widget-sales-flight-type.component.html',
})
export class WidgetSalesFlightTypeComponent extends WidgetComponentBaseComponent
    implements OnInit, OnDestroy {
    isLoading: boolean;
    data: LinearChartDto[];
    selectedDateRange: moment.Moment[] = [
        moment().add(-1, 'months').startOf('day'),
        moment().endOf('day'),
    ];
    @ViewChild('widgetContent') content: ElementRef<HTMLElement>;
    selectedAgency: string;
    view: number[];

    constructor(
        injector: Injector,
        private analyticsService: AnalyticsDashboardServiceProxy
    ) {
        super(injector);
    }

    ngOnInit() {
        this.subDateRangeFilter();
        this.subAgencyFilter();
    }
    ngOnDestroy() {
        this.unSubDateRangeFilter();
        this.unSubAgencyFilter();
    }

    onDateRangeFilterChange = (dateRange) => {
        this.runDelayed(() => {
            if (
                !dateRange ||
                dateRange.length !== 2 ||
                (this.selectedDateRange[0] === dateRange[0] &&
                    this.selectedDateRange[1] === dateRange[1])
            ) {
                return;
            }

            this.selectedDateRange = dateRange;
            this.getData();
        });
    }

    getData() {
        this.isLoading = true;
        this.analyticsService
            .getSalesByFlightType(
                this.selectedDateRange[0],
                this.selectedDateRange[1],
                this.selectedAgency
            )
            .pipe(
                finalize(() => {
                    this.isLoading = false;
                })
            )
            .subscribe((data) => {
                this.data = data;
                this.isLoading = false;
            });
    }

    subDateRangeFilter() {
        abp.event.on(
            'app.dashboardFilters.dateRangePicker.onDateChange',
            this.onDateRangeFilterChange
        );
    }

    unSubDateRangeFilter() {
        abp.event.off(
            'app.dashboardFilters.dateRangePicker.onDateChange',
            this.onDateRangeFilterChange
        );
    }

    onAgencyChange = (agency) => {
        this.runDelayed(() => {
            this.selectedAgency = agency;
            this.getData();
        });
    }

    subAgencyFilter() {
        abp.event.on(
            'app.dashboardFilters.dateRangePicker.onAgencyChange',
            this.onAgencyChange
        );
    }

    unSubAgencyFilter() {
        abp.event.off(
            'app.dashboardFilters.dateRangePicker.onAgencyChange',
            this.onAgencyChange
        );
    }
}
